<template>
  <div>
    <div style="padding-bottom:20px;cursor:pointer" @click="triggerHide">
      <h2 style="padding-right:10px;padding-bottom:5px;display:inline">{{ $t('common.fabrics') }}</h2>
      <svg-icon :hidden="!hide" :size="1.5" icon-class="arrow-right" />
      <svg-icon :hidden="hide" :size="1.5" icon-class="arrow-down" />
    </div>
    <div :hidden="hide">
      <pagination
        :page-sizes="[10, 20, 50, 100]"
        :pager-count="5"
        layout="pager, ->, total, sizes"
        :total="totalItems"
        :page.sync="listParams.page"
        :limit.sync="listParams.limit"
        @pagination="getFilteredAndPaginatedItems"
      >
      </pagination>
      <el-table
        ref="fabricTable"
        :data="filteredAndPaginatedItems"
        border
        row-key="id"
        fit
        @select="rowSelected"
        @select-all="selectAllWithFilters"
        @selection-change="emitValues"
      >
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input
              v-model="filter['productCode']"
              class="search"
              size="mini"
              :placeholder="$t('fabric.domainProductCode')"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('fabric.domainProductCode')" prop="code">
            <template slot-scope="scope">
              <span>{{ scope.row['domainProductCode'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input
              v-model="filter['description']"
              class="search"
              size="mini"
              :placeholder="$t('fabric.description')"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('fabric.description')" prop="name">
            <template slot-scope="scope">
              <span>{{ scope.row['description'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-select
              v-model="filter['status']"
              clearable
              :required="false"
              :placeholder="$t('fabric.fabricStatusOption')"
            >
              <el-option
                v-for="item in fabricStatuses"
                :key="item.code"
                :label="item.description"
                :value="item.code"
                style="z-index:7000 !important"
              />
            </el-select>
          </template>
          <el-table-column :label="$t('fabric.fabricStatusOption')">
            <template slot-scope="scope">
              <span>{{ getFabricStatusOptionFromRow(scope.row.fabricStatusOption) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <el-table-column
            reverse-selection="true"
            fixed="right"
            type="selection"
            width="40"
            align="center"
            :selectable="() => true"
          />
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import SvgIcon from '@/components/SvgIcon';

const debounce = require('lodash.debounce');

export default {
  name: 'FabricTable',
  components: {
    Pagination,
    SvgIcon
  },
  props: {
    domainID: {
      type: Number
    }
  },
  data() {
    return {
      loading: true,
      errorMsg: '',
      multipleSelection: [],
      filteredAndPaginatedItems: [],
      totalItems: 0,
      filter: {},
      hide: false,
      previousSelection: [],
      allItems: [],
      pageSwitched: false,
      page: 1,
      pageSize: 10
    };
  },
  computed: {
    listParams() {
      return {
        page: this.page,
        limit: this.pageSize
      };
    },
    fabricStatuses() {
      return this.$store.getters['option/loadedOptions']('fabricStatus');
    }
  },
  watch: {
    domainID() {
      this.$store.dispatch('fabric/getItems', { query: { domainid: this.domainID } }).then(() => {
        this.page = 1;
        const allItems = this.$store.getters['fabric/loadedItems'];
        allItems
          .filter(i => i.selectedYN)
          .forEach(i => {
            i.selectedYN = false;
            this.$refs.fabricTable.toggleRowSelection(i, false);
          });
        this.itemsForDomain = allItems.filter(e => e.domainID === this.domainID);
        this.getFilteredAndPaginatedItems();
      });
    },
    filter: {
      deep: true,
      handler: function(value) {
        this.listParams.page = 1;
        this.debouncedGetFilteredAndPaginatedItems();
      }
    }
  },
  created() {
    this.debouncedGetFilteredAndPaginatedItems = debounce(this.getFilteredAndPaginatedItems, 300);
  },
  methods: {
    rowSelected(selection, row) {
      row.selectedYN = !row.selectedYN;
    },
    emitValues() {
      this.$emit('input', { showPanelFabricIDs: this.itemsForDomain.filter(i => i.selectedYN).map(i => i.id) });
    },
    triggerHide() {
      this.hide = !this.hide;
    },
    selectAllWithFilters() {
      const items = this.getFilteredItems();

      if (items.every(i => i.selectedYN)) {
        this.multipleSelection = [];
        items.forEach(i => {
          i.selectedYN = false;
          this.$refs.fabricTable.toggleRowSelection(i, false);
        });
      } else {
        this.multipleSelection = items;
        items.forEach(i => {
          i.selectedYN = true;
          this.$refs.fabricTable.toggleRowSelection(i, true);
        });
      }
      this.emitValues();
    },
    getFabricStatusOptionFromRow(status) {
      const option = this.$store.getters['option/loadedOptions']('fabricStatus').find(item => item.code === status);
      return option && option.description;
    },
    getFilteredAndPaginatedItems() {
      const items = this.getFilteredItems();
      this.totalItems = items.length;

      // paginate
      const startIndex = (this.listParams.page - 1) * this.listParams.limit;
      const endIndex = startIndex + this.listParams.limit;
      this.filteredAndPaginatedItems = items.slice(startIndex, endIndex);

      // set selected items for new page
      this.$nextTick(() => {
        this.filteredAndPaginatedItems
          .filter(row => row.selectedYN)
          .forEach(row => this.$refs.fabricTable.toggleRowSelection(row, true));
      });
    },
    getFilteredItems() {
      let items = this.itemsForDomain;

      // filter
      if (this.filter.productCode) {
        items = items.filter(i => i.domainProductCode.includes(this.filter.productCode));
      }
      if (this.filter.description) {
        const lowerCaseDescriptionFilter = this.filter.description.toLowerCase();
        items = items.filter(i => i.description.toLowerCase().includes(lowerCaseDescriptionFilter));
      }
      if (this.filter.status || this.filter.status === 0) {
        items = items.filter(i => i.fabricStatusOption === this.filter.status);
      }

      return items;
    }
  }
};
</script>
